import { render, staticRenderFns } from "./member_login.vue?vue&type=template&id=72823dec&scoped=true"
import script from "./member_login.vue?vue&type=script&lang=js"
export * from "./member_login.vue?vue&type=script&lang=js"
import style0 from "./member_login.vue?vue&type=style&index=0&id=72823dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72823dec",
  null
  
)

export default component.exports